import Tooltip from "../../common/Tooltip";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Button from "../../common/Button";
import { capitalize, upperCase } from "../../../utils/manipulateText";
import DatePicker from "../../common/DatePicker";
import { useBusinessBreakdownAndFilters } from "../BusinessBreakdownAndFilters";
import { useTranslation } from "react-i18next";

function Filter({ loading, onRefreshReport, setInitState }) {
  const {
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    breakdowns,
    setTableBreakdowns,
  } = useBusinessBreakdownAndFilters();

  const onDateChange = (e) => {
    setEndDate(e.endDate);
    setStartDate(e.startDate);
  };

  const { t } = useTranslation();

  return (
    <div className="pt-2 w-full md:w-auto">
      <label className="leading-8 text-gray-600 font-semibold text-sm ml-1">
        {capitalize(t("filter"))}
      </label>
      <br />
      <div className="flex flex-wrap items-center">
        <Tooltip title="date range" content={"you can filter date range."}>
          <div className="mb-1 md:mb-0 mx-1">
            <DatePicker
              mode="range"
              startDate={startDate}
              endDate={endDate}
              onChange={onDateChange}
            />
          </div>
        </Tooltip>

        <div className="mx-1 mb-1 md:mb-0 flex items-center justify-center ">
          <Tooltip
            title="refresh report"
            content={"you can refresh report."}
            customStyle="w-fit"
          >
            <Button
              loading={loading}
              color="empower"
              onClick={() => {
                setTableBreakdowns([]);
                onRefreshReport();
              }}
              icon={faSyncAlt}
            >
              <span className="2xl:hidden">
                {upperCase(t("apply filters"))}
              </span>
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}

export default Filter;
